import { Navigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth, type PermissionKey, type UiRole } from "@/auth/AuthContext";

export function ProtectedRoute({
  children,
  requiredRole,
  requiredPermissions
}: {
  children: React.ReactNode;
  requiredRole?: UiRole;
  requiredPermissions?: PermissionKey[];
}) {
  const { user, isHydrating } = useAuth();
  const location = useLocation();

  if (isHydrating) {
    return (
      <div className="min-h-screen w-full flex items-center justify-center">
        <div className="flex items-center gap-2 text-muted-foreground">
          <Loader2 className="size-5 animate-spin" />
          <span>Loading...</span>
        </div>
      </div>
    );
  }

  if (!user) {
    const returnTo = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?returnTo=${returnTo}`} replace />;
  }

  if (requiredRole && user.role !== requiredRole) {
    return <Navigate to="/dashboard" replace />;
  }

  if (
    requiredPermissions?.length &&
    !requiredPermissions.every((p) => user.permissions?.[p])
  ) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
}

